import * as React from "react";
import PropTypes from 'prop-types';

const SvgVideo = props => {
  if (props.id !== "_svgvideo") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 20 20" fill="none" {...props}><circle cx={10} cy={10} r={9.5} stroke="#4d4d4d" /><path d="M15.5 9.134a1 1 0 010 1.732L8 15.196a1 1 0 01-1.5-.866V5.67A1 1 0 018 4.804l7.5 4.33z" fill="#4d4d4d" /></svg>;
};

SvgVideo.displayName = "_svgvideo";
SvgVideo.propTypes = {
  id: PropTypes.string
};
SvgVideo.defaultProps = {
  id: ''
};
export default SvgVideo;